import React from 'react';
import useAuthenticationState from '~/ducks/authentication/use-authentication-state';
import { useUptime } from '~/domain/uptime/hooks/use-uptime';
import * as S from './styled';

export const UptimeCompanyInfo = () => {
  const { isUptime } = useUptime();
  const authentication = useAuthenticationState();
  return isUptime ? <S.WrapperDiv>{authentication.companyName}</S.WrapperDiv> : null;
};

export default UptimeCompanyInfo;
